import React, { useState, useEffect } from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import HeaderApp from "../../components/HeaderApp";
import EvidenceForm from "../../components/EvidenceForm";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getEvidencia } from "../../services/evidenciasService";

const getEvidenceId = (ev) =>
  ev?.idevidencias ?? ev?.id ?? ev?.Id ?? ev?.ID ?? ev?.idEvidencia ?? ev?.IdEvidencia ?? ev?.Id_Evidencia;

const EvidenciaFormPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const isNew = !id || id === "nueva";
  const [evidencia, setEvidencia] = useState(null);
  const [loadingEvidencia, setLoadingEvidencia] = useState(!isNew);

  useEffect(() => {
    if (isNew) {
      setEvidencia(null);
      setLoadingEvidencia(false);
      return;
    }
    const evFromState = location.state?.evidencia;
    if (evFromState && String(getEvidenceId(evFromState)) === String(id)) {
      setEvidencia(evFromState);
      setLoadingEvidencia(false);
      return;
    }
    getEvidencia(id)
      .then((data) => {
        const item = data?.data ?? data;
        setEvidencia(item ?? null);
      })
      .catch(() => setEvidencia(null))
      .finally(() => setLoadingEvidencia(false));
  }, [id, isNew, location.state]);

  const handleSuccess = () => {
    navigate("/Evidencias");
  };

  if (!isNew && loadingEvidencia) {
    return (
      <>
        <HeaderApp />
        <Box component="main" sx={{ flex: 1, py: 4, px: 2, bgcolor: "background.default", minHeight: "calc(100vh - 64px)" }}>
          <Container maxWidth="md">
            <Typography color="text.secondary">Cargando evidencia...</Typography>
          </Container>
        </Box>
      </>
    );
  }

  return (
    <>
      <HeaderApp />
      <Box
        component="main"
        sx={{
          flex: 1,
          py: 4,
          px: 2,
          bgcolor: "background.default",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        <Container maxWidth="md">
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("/Evidencias")} sx={{ mb: 2 }}>
            Volver a evidencias
          </Button>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
            {isNew ? "Agregar evidencia" : "Editar evidencia"}
          </Typography>
          <EvidenceForm evidenciaData={isNew ? null : evidencia} onSuccess={handleSuccess} />
        </Container>
      </Box>
    </>
  );
};

export default EvidenciaFormPage;
